
'use strict';

var _ = require('underscore');
var SoaModel = require('bunsen/models/SoaModel');
var Action = SoaModel.extend();

_.extend(Action.prototype, {
    isCode : function (code) {
        return this.get('code') === code;
    }
});


//constants
_.extend(Action, {
    CODE_ADMIN_APPROVES_AUTH_REVIEW: "ADMIN_APPROVES_AUTH_REVIEW",
    CODE_ADMIN_PROVIDES_FIRSTDIBS_QUOTE: "ADMIN_PROVIDES_FIRSTDIBS_QUOTE",
    CODE_ADMIN_PROVIDE_ACCOUNTING_QUOTE: "ADMIN_PROVIDE_ACCOUNTING_QUOTE",
    CODE_ADMIN_MARK_SHIPPED: "ADMIN_MARK_SHIPPED",
    CODE_ADMIN_MARK_DELIVERED: "ADMIN_MARK_DELIVERED",
    CODE_ADMIN_CORRECT_SHIPPING: "ADMIN_CORRECT_SHIPPING",
    CODE_ADMIN_WIRE_TRANSFER_DETAILS: "ADMIN_WIRE_TRANSFER_DETAILS",
    CODE_ADMIN_WIRE_TRANSFER_CAPTURE: "ADMIN_WIRE_TRANSFER_CAPTURE",
    CODE_ADMIN_CHECK_DETAILS: "ADMIN_CHECK_DETAILS",
    CODE_ADMIN_CHECK_CAPTURE: "ADMIN_CHECK_CAPTURE",
    CODE_ADMIN_MANUAL_CAPTURE: "ADMIN_MANUAL_CAPTURE",
    CODE_ADMIN_REFUND_CAPTURE: "ADMIN_REFUND_CAPTURE",
    CODE_ADMIN_MODIFY_SHIPMENT_QUOTE: "ADMIN_MODIFY_SHIPMENT_QUOTE",
    CODE_ADMIN_MODIFY_ORDER: "ADMIN_MODIFY_ORDER",
    CODE_ADMIN_ADD_BUYER_PMT_AUTH: "ADMIN_ADD_BUYER_PMT_AUTH",
    CODE_ADMIN_ADD_DEALER_PMT_AUTH: "ADMIN_ADD_DEALER_PMT_AUTH",
    CODE_ADMIN_BUYER_REAUTH_PMT: "BUYER_REAUTH_PMT",

    CODE_DEALER_COUNTER_OFFER_PRE_CHECKOUT: "DEALER_COUNTER_OFFER_PRE_CHECKOUT",
    CODE_DEALER_ACCEPT_OFFER_PRE_CHECKOUT: "DEALER_ACCEPT_OFFER_PRE_CHECKOUT",
    CODE_DEALER_AMEND_OFFER_PRE_CHECKOUT: "DEALER_AMEND_OFFER_PRE_CHECKOUT",

    CODE_DEALER_MARK_ITEM_NOT_AVAILABLE: "DEALER_MARK_ITEM_NOT_AVAILABLE",
    CODE_DEALER_REQUEST_FIRSTDIBS_QUOTE: "DEALER_REQUEST_FIRSTDIBS_QUOTE",
    CODE_DEALER_PROVIDE_QUOTE: "DEALER_PROVIDE_QUOTE",
    CODE_DEALER_REVIEW_FIRSTDIBS_QUOTE: "DEALER_REVIEW_FIRSTDIBS_QUOTE",
    CODE_DEALER_ACCEPT_OFFER: "DEALER_ACCEPT_OFFER",
    CODE_DEALER_COUNTER_OFFER: "DEALER_COUNTER_OFFER",
    CODE_DEALER_MARK_SHIPPED: "DEALER_MARK_SHIPPED",
    CODE_DEALER_MARK_READY_FOR_PICKUP: "DEALER_MARK_READY_FOR_PICKUP",

    // will be removed when N2.0 is released
    CODE_BUYER_CHECKOUT_OFFER: "BUYER_CHECKOUT_OFFER",

    CODE_BUYER_ACCEPT_OFFER: "BUYER_ACCEPT_OFFER",
    CODE_BUYER_CHECKOUT_SUBMITTED_DEALER_OFFER: "BUYER_CHECKOUT_SUBMITTED_DEALER_OFFER",
    CODE_BUYER_CHECKOUT_ACCEPTED_BUYER_OFFER: "BUYER_CHECKOUT_ACCEPTED_BUYER_OFFER",
    CODE_BUYER_PASS_OFFER_PRE_CHECKOUT: "BUYER_PASS_OFFER_PRE_CHECKOUT",
    CODE_BUYER_COUNTER_OFFER_PRE_CHECKOUT: "BUYER_COUNTER_OFFER_PRE_CHECKOUT",
    CODE_BUYER_NOT_INTERESTED_OFFER_PRE_CHECKOUT: "BUYER_NOT_INTERESTED_OFFER_PRE_CHECKOUT",
    CODE_BUYER_COUNTER_OFFER: "BUYER_COUNTER_OFFER",
    CODE_BUYER_BALANCE_DUE: "BUYER_BALANCE_DUE",
    CODE_BUYER_MARK_SHIPPED: "BUYER_MARK_SHIPPED",
    CODE_BUYER_SUBMIT_INVOICE: "BUYER_SUBMIT_INVOICE"
});

module.exports = Action;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/Action.js
// module id = 51
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55